import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PenLine, X } from "lucide-react";

const shouldShow = () => {
  const now = new Date();
  return now.getDay() === 5 || now.getHours() >= 15;
};

export const SignOffReminder = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(sessionStorage.getItem("signoff_reminder_dismissed") === "1");

  useEffect(() => {
    if (!user || user.role === "client" || !shouldShow()) return;
    api.get("/signoff/reminders").then(({ data }) => setData(data)).catch(() => {});
  }, [user, location.pathname]); // eslint-disable-line

  if (!user || dismissed || !data || data.count === 0 || location.pathname === "/signoff") return null;
  const isManager = ["admin", "supervisor", "foreman"].includes(user.role);

  return (
    <div className="bg-amber-500 text-white px-4 py-2 mb-4 flex items-center gap-3 text-sm font-semibold" data-testid="signoff-reminder">
      <PenLine size={16} className="shrink-0" />
      <button data-testid="signoff-reminder-link" onClick={() => navigate("/signoff")} className="flex-1 text-left underline underline-offset-2">
        {isManager
          ? `Sign-off reminder: ${data.count} entr${data.count === 1 ? "y" : "ies"} still unsigned this week (${data.employees.slice(0, 4).join(", ")}${data.employees.length > 4 ? "…" : ""}) — tap to open Sign-Off`
          : `You have ${data.count} unsigned time entr${data.count === 1 ? "y" : "ies"} this week — tap to sign off before payroll`}
      </button>
      <button data-testid="signoff-reminder-dismiss" onClick={() => { sessionStorage.setItem("signoff_reminder_dismissed", "1"); setDismissed(true); }} aria-label="Dismiss">
        <X size={16} />
      </button>
    </div>
  );
};

export default SignOffReminder;
